import { WorkspaceServiceAccountRoute } from './-route-wrappers';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute(
  '/_authenticated/workspaces/$workspaceId/settings/api_credentials/service_accounts/$serviceAccountId',
)({
  component: WorkspaceServiceAccountRoute,
});
